import styled from 'styled-components';
import { theme } from '../../theme/GlobalTheme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100%;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 600px;
  padding: 20px;
  box-sizing: border-box;
`;

export const Form = styled.form`
  padding: 20px;
  border: 2px solid #ddd;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const Button = styled.button`
  border: none;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  width: 100%;
  text-align: center;
  padding: 15px;
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-top: ${theme.spacing.md};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;

  &:hover {
    background-color: ${theme.colors.secondary};
    color: ${theme.colors.white};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.light};
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    
    &:hover {
      transform: none;
      background-color: ${theme.colors.primary};
    }
  }
`;

export const Highlight = styled.span`
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.primary};
`;